import { render, staticRenderFns } from "./HealthInsuranceCard.component.vue?vue&type=template&id=92e40c40&scoped=true"
import script from "./HealthInsuranceCard.component.vue?vue&type=script&lang=js"
export * from "./HealthInsuranceCard.component.vue?vue&type=script&lang=js"
import style0 from "./HealthInsuranceCard.component.vue?vue&type=style&index=0&id=92e40c40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e40c40",
  null
  
)

export default component.exports